export const synbioImages = [
    {
        url: 'https://static.igem.wiki/teams/4241/wiki/ihp/synbio/lab-crop.jpeg',
        caption: 'Secondary students doing some hands on experiment on agarose gel electrophoresis',
    },
    {
        url: 'https://static.igem.wiki/teams/4241/wiki/ihp/synbio/c5528574-77f0-4795-82ed-263457f94b63.jpeg',
        caption: ' Synthetic Biology Fair at Tam Wing Fan InnoWing II'
    },
    {
        url: 'https://static.igem.wiki/teams/4241/wiki/ihp/synbio/7951eddd-40b0-4654-b66b-201ebf3b3023.jpeg',
        caption: 'Secondary School students participating in a session on the basics of synthetic biology'
    },

    {
        url: 'https://static.igem.wiki/teams/4241/wiki/ihp/synbio/fb31bb92-47db-473a-b9af-551a8a22abd9.jpeg',
        caption: 'Lecture on Polymerase Chain Reaction'
    },
    {
        url: 'https://static.igem.wiki/teams/4241/wiki/ihp/synbio/4cbfb6ba-94c7-4c0c-8369-4570d9d8f83c.jpeg',
        caption: ''
    },
]

export const bioinfoImages = [

    {
        url: 'https://static.igem.wiki/teams/4241/wiki/ihp/bioinfo/whatsapp-image-2022-08-16-at-22-04-39.jpeg',
        caption: 'Bioinformatics Workshop by HKU BioMed x HKU iGEM 2022'
    },
    {
        url: 'https://static.igem.wiki/teams/4241/wiki/ihp/bioinfo/screenshot-2022-10-09-at-11-40-11-3.png',
        caption: 'Example of codon translation activity'
    },
    {
        url: 'https://static.igem.wiki/teams/4241/wiki/ihp/bioinfo/img-20220817-160404.jpg',
        caption: 'Dr. Joshua Ho introducing the field of bioinformatics'
    },
];

export const JSSEImages = [
    {
        url: 'https://static.igem.wiki/teams/4241/wiki/ihp/jsse/whatsapp-image-2022-09-11-at-16-45-45.jpeg',
        caption: 'The 2022 HKU iGEM booth at the 55th JSSE'
    },

    {
        url: 'https://static.igem.wiki/teams/4241/wiki/ihp/jsse/whatsapp-image-2022-09-11-at-16-46-00.jpeg',
    },
    {
        url: 'https://static.igem.wiki/teams/4241/wiki/ihp/jsse/whatsapp-image-2022-09-11-at-16-46-01.jpeg',
    },
    {
        url: 'https://static.igem.wiki/teams/4241/wiki/ihp/jsse/whatsapp-image-2022-09-11-at-16-46-03.jpeg',
        caption: 'We displayed petri dishes with different bacterial selection methods.'
    },
]
